import { render, staticRenderFns } from "./OverBillingView.vue?vue&type=template&id=cd18ce4a&scoped=true&"
import script from "./OverBillingView.vue?vue&type=script&lang=ts&"
export * from "./OverBillingView.vue?vue&type=script&lang=ts&"
import style0 from "./OverBillingView.vue?vue&type=style&index=0&id=cd18ce4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd18ce4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VExpandTransition,VRow,VSimpleTable,VSpacer})
